import { Box, Typography } from "@mui/material";
import React from "react";
import CustomTextField from "../../../../../components/common/Textfield";
import { StepComponentProps } from "../../AddBookingV2";
import VenueSearchField from "../VenueSearchField";
import StepHeader from "../StepHeader";

const FuneralServiceStep: React.FC<StepComponentProps> = ({
  bookingData,
  setBookingData,
  isEdit,
  onUpdate,
  submitting,
}) => {
  const handleChange = (field: string, value: string) =>
    setBookingData((prev) => ({ ...prev, [field]: value }));

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3 }}
    >
      <StepHeader
        title="Service Details"
        isEdit={isEdit}
        onUpdate={onUpdate}
        submitting={submitting}
      />

      {/* Timing */}
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Date of Service"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={bookingData.date_of_service || ""}
          onChange={(e) => handleChange("date_of_service", e.target.value)}
        />
        <CustomTextField
          label="Start Time"
          type="time"
          InputLabelProps={{ shrink: true }}
          value={bookingData.start_time || ""}
          onChange={(e) => handleChange("start_time", e.target.value)}
        />
        <CustomTextField
          label="End Time"
          type="time"
          InputLabelProps={{ shrink: true }}
          value={bookingData.end_time || ""}
          onChange={(e) => handleChange("end_time", e.target.value)}
        />
      </Box>

      {/* Venue */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 3,
          alignItems: "start",
        }}
      >
        <VenueSearchField
          bookingData={bookingData}
          setBookingData={setBookingData}
        />
        <CustomTextField
          label="Address One"
          value={bookingData.address_one || ""}
          onChange={(e) => handleChange("address_one", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="Address Two"
          value={bookingData.address_two || ""}
          onChange={(e) => handleChange("address_two", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Suburb"
          value={bookingData.suburb || ""}
          onChange={(e) => handleChange("suburb", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <CustomTextField
          label="City"
          value={bookingData.city || ""}
          onChange={(e) => handleChange("city", e.target.value)}
          disabled={bookingData.areAddressFieldsDisabled}
        />
        <Box />
      </Box>

      {/* Optional */}
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 1 }}>
        Additional Information (Optional)
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 3 }}>
        <CustomTextField
          label="Name of Priest"
          value={bookingData.preacher_name || ""}
          onChange={(e) => handleChange("preacher_name", e.target.value)}
        />
        <CustomTextField
          label="Name of MC"
          value={bookingData.mc_name || ""}
          onChange={(e) => handleChange("mc_name", e.target.value)}
        />
        <CustomTextField
          label="Name of Eulogist"
          value={bookingData.eulogist_name || ""}
          onChange={(e) => handleChange("eulogist_name", e.target.value)}
        />
      </Box>
      <CustomTextField
        label="Service Notes"
        multiline
        rows={3}
        value={bookingData.service_notes || ""}
        onChange={(e) => handleChange("service_notes", e.target.value)}
      />
    </Box>
  );
};

export default FuneralServiceStep;
